import { Action } from './action';
import { zoomToNodes } from './zoom';

// 请求系统全屏
const requestFullscreen = () => {
  if (document.documentElement.requestFullscreen) {
    return document.documentElement.requestFullscreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    return document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    return document.documentElement.msRequestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    return document.documentElement.mozRequestFullScreen();
  }
};

export async function presentationHandler(stageContext) {
  if (stageContext.mode === 'presentation') return;
  stageContext.mode = 'presentation';
  stageContext.hooks.exitPresentation = exit;
  stageContext.hooks.onFrameChange();
  stageContext.hooks.cancelSelectionMenu();

  // 获取当前画布元素
  const presentationContainer = stageContext.canvas.interactive.parentNode;

  // 监听全屏变化事件
  const fullscreenChangeHandler = () => {
    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement &&
      !document.mozFullScreenElement
    ) {
      // 如果用户通过系统方式退出全屏，也执行我们的退出逻辑
      exit();
    }
  };

  document.addEventListener('fullscreenchange', fullscreenChangeHandler);
  document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler);
  document.addEventListener('msfullscreenchange', fullscreenChangeHandler);
  document.addEventListener('mozfullscreenchange', fullscreenChangeHandler);
  // 创建全屏演示容器
  presentationContainer.id = 'presentation-mode';
  presentationContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #000;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    `;

  // 尝试进入全屏模式
  await requestFullscreen();

  // 添加退出按钮
  const exitButton = document.createElement('button');
  exitButton.textContent = '退出演示';
  exitButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 8px 16px;
        background: rgba(255,255,255,0.2);
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background 0.3s;
    `;

  setTimeout(() => {
    exitButton.style.opacity = '0';
  }, 800);

  exitButton.addEventListener('mouseover', () => {
    exitButton.style.opacity = '1';
    exitButton.style.background = 'rgba(255,255,255,0.3)';
  });
  exitButton.addEventListener('mouseout', () => {
    exitButton.style.opacity = '0';
  });
  exitButton.addEventListener('click', exit);

  function exit() {
    stageContext.mode = '';
    exitButton.remove();
    stageContext.hooks.exitPresentation = null;
    stageContext.hooks.onFrameChange();
    stageContext.hooks.onSelectionChangeCallback();
    // 退出全屏模式
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((err) => {
        console.error('Error exiting fullscreen:', err);
      });
    } else if (document.webkitFullscreenElement) {
      document.webkitExitFullscreen();
    } else if (document.msFullscreenElement) {
      document.msExitFullscreen();
    } else if (document.mozFullscreenElement) {
      document.mozExitFullscreen();
    }
    presentationContainer.style.cssText = '';
    document.removeEventListener('keydown', handleKeyDown);
    document.removeEventListener('fullscreenchange', fullscreenChangeHandler);
    document.removeEventListener('webkitfullscreenchange', fullscreenChangeHandler);
    document.removeEventListener('msfullscreenchange', fullscreenChangeHandler);
    document.removeEventListener('mozfullscreenchange', fullscreenChangeHandler);

    const frames = stageContext.api.getFrames();
    const frame = frames.find((node) => node.id === stageContext.currentFrameId) || frames[0];
    zoomToNodes(stageContext, [frame], 200);
  }

  // 键盘事件处理
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      exit();
    }

    // Handle arrow key navigation between frames
    else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      // Navigate to next frame
      const frames = stageContext.api.getFrames();
      const currentFrameIndex = frames.findIndex((f) => f.id === stageContext.currentFrameId);
      const nextIndex = (currentFrameIndex + 1) % frames.length;
      if (nextIndex !== currentFrameIndex) {
        renderFrame(stageContext, frames[nextIndex]);
      }
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      // Navigate to previous frame
      const frames = stageContext.api.getFrames();
      const currentFrameIndex = frames.findIndex((f) => f.id === stageContext.currentFrameId);
      const prevIndex = (currentFrameIndex - 1 + frames.length) % frames.length;
      if (prevIndex !== currentFrameIndex) {
        renderFrame(stageContext, frames[prevIndex]);
      }
    }
  };

  // 添加元素到DOM
  presentationContainer.appendChild(exitButton);

  const frames = stageContext.api.getFrames();
  const frame = frames[0];
  renderFrame(stageContext, frame);

  // 添加键盘事件监听
  document.addEventListener('keydown', handleKeyDown);
}

function renderFrame(stageContext, frame) {
  zoomToNodes(stageContext, [frame], 1);
  stageContext.currentFrameId = frame.id;
}

export const presentationAction = new Action({
  name: 'Presentation',
  handler: presentationHandler,
  shortcuts: 'CTRL+\\',
});
